export const createHeadline = ({ headlineTitle }) => headlineTitle || 'The beauty society';
